export const tabChange = tab => ({
  type: "TAB",
  tab
});
export const sidebarExpand = isExpand => ({
  type: "SIDEBAR",
  isExpand
});
export const pageTitle = title => ({
  type: "TITLE",
  title
});
export const socketManager = socket => ({
  type: "SOCKET",
  socket
});
